// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3332":"9f1f2bece675a25f","5285":"0c3c599828350c7e"}[chunkId] + ".css";
};